// 2024/01/03 Leading Win 教育機能対応 DXWEBEDU00200_画像送付 start
import styled from 'styled-components';

export const SendPhotoStyled = styled.div`
  body.no-scroll {
    overflow: hidden !important;
  }
  .body {
    display: flex;
    flex-wrap: wrap;
    height: 100%;
    border-radius: 8px;
    background-color: #ffffff;
    box-shadow: var(--box-shadow);
    padding-bottom: 5px;
    position: relative;
    margin-top: 5px;
    overflow: hidden !important;
  }
  .appPopuSty {
    font-size: 25px;
    font-weight: 650;
  }
  .title {
    font-size: 20px;
    letter-spacing: 0;
    line-height: 30px;
    font-weight: 600;
    margin-top: 5px;
    margin-bottom: 5px;
    margin-left: 40px;
    width: 100%;
  }
  .tableSty {
    font-size: 20px;
    font-weight: 600;
    margin-top: 60px;
    margin-left: 26%;
    width: 100%;
    .boder-center {
      text-align: center;
    }
    .pagination {
      padding-top: 24px;
      padding-bottom: 5px;
      text-align: center;
    }
    .aStyle {
      text-decoration: underline;
    }
    .allCheckBox {
      font-size: 15px !important;
    }
  }
  .photoSty {
    font-size: 20px;
    font-weight: 600;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    .avatar-uploader {
      width: 640px;
      height: 480px;
      margin-left: 25px;
      .ant-upload {
        width: 640px;
        height: 480px;
      }
    }
  }
  .buttonSty {
    width: 800px;
    display: flex;
    justify-content: space-between;
  }
  .formStyle {
    width: 70%;
    margin-left: 26%;
  }
`;
// 2024/01/03 Leading Win 教育機能対応 DXWEBEDU00200_画像送付 start
